

    <svg:text class="io-type" [ngClass]="{'activated-io-type': activate}" [attr.x]="textX" [attr.y]="textY"
              font-size="14"
              [attr.text-anchor]="anchor">
      <svg:tspan font-weight="bold">{{ name }}</svg:tspan>
      <svg:tspan>:</svg:tspan>
      <svg:tspan>{{ typeText }}</svg:tspan>
    </svg:text>

    <svg:circle *ngIf="initialized" (mouseenter)="onMouseEnter($event)" (mouseleave)="onMouseLeave($event)"
                xmlns:svg="http://www.w3.org/1999/html" [attr.cx]="specification.at.x"
                [attr.cy]="specification.at.y" fill="#fff" stroke="#00F" stroke-width="1"
                [class.highlighted-point]="highlight"
                [attr.r]="radius"/>
  


// WEBPACK FOOTER //
// ./src/library/graph/vertex/interaction-point/workflow-graph-vertex-inlet-point.component.ts.WorkflowGraphVertexInletPointComponent.html